import styled from 'styled-components';

export const Text = styled.div<{ maxWidth?: string }>`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : '100%')};
  width: 100%;
`;

export const SubCategory = styled.div`
  font-size: 16px;
  color: #000;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const TopFilterBar = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex: 1;
`;

export const TopSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background: #fff;
  width: 100%;
`;

export const TableContainer = styled.div`
  position: relative;
  margin-top: 10px;
  width: 100%;
  height: calc(100% - 77px - 42px);
  z-index: 1;

  > div.ant-table-wrapper {
    height: 100%;

    > div.ant-spin-nested-loading {
      height: 100%;

      > div.ant-spin-container {
        height: 100%;

        .ant-table {
          height: calc(100% - 48px);

          .ant-table-container {
            height: 100%;
          }
        }
      }
    }

    .ant-pagination {
      margin-bottom: 0;
    }
  }

  .disabled-row td > div {
    opacity: 0.4;
  }

  .disabled-row td > .operations {
    opacity: 1;
  }
`;
